<div class="news-feed-v2" [ngStyle]="{ 'background-color': attributes.NewsFeedBoxBgcolor }">
    <ng-content></ng-content>
</div>
